import {iconUrl} from 'data/icon'
import {ensureStatuses} from '../type'

export const AST = ensureStatuses({

	COMBUST: {
		id: 838,
		name: 'Combust',
		icon: iconUrl(213213),
		duration: 30000,
	},

	COMBUST_II: {
		id: 843,
		name: 'Combust II',
		icon: iconUrl(213214),
		duration: 30000,
	},

	COMBUST_III: {
		id: 1881,
		name: 'Combust III',
		icon: iconUrl(213248),
		duration: 30000,
	},

	ASPECTED_BENEFIC: {
		id: 835,
		name: 'Aspected Benefic',
		icon: iconUrl(213215),
		duration: 15000,
	},

	ASPECTED_HELIOS: {
		id: 836,
		name: 'Aspected Helios',
		icon: iconUrl(213216),
		duration: 15000,
	},

	ENHANCED_BENEFIC_II: {
		id: 815,
		name: 'Enhanced Benefic II',
		icon: iconUrl(213228),
		duration: 15000,
	},

	LIGHTSPEED: {
		id: 841,
		name: 'Lightspeed',
		icon: iconUrl(213220),
		duration: 15000,
	},

	SYNASTRY_SELF: {
		id: 845,
		name: 'Synastry (self)',
		icon: iconUrl(213223),
		duration: 20000,
	},

	SYNASTRY: {
		id: 846,
		name: 'Synastry',
		icon: iconUrl(213224),
		duration: 20000,
	},

	COLLECTIVE_UNCONSCIOUS: {
		id: 848,
		name: 'Collective Unconscious',
		icon: iconUrl(213227),
		duration: 18000,
	},

	COLLECTIVE_UNCONSCIOUS_MITIGATION: {
		id: 849,
		name: 'Collective Unconscious (Mitigation)',
		icon: iconUrl(213226),
		duration: 5000,
	},

	WHEEL_OF_FORTUNE: {
		id: 956,
		name: 'Wheel Of Fortune',
		icon: iconUrl(213225),
		duration: 15000,
	},

	EARTHLY_DOMINANCE: {
		id: 1224,
		name: 'Earthly Dominance',
		icon: iconUrl(213241),
		duration: 10000,
	},

	GIANT_DOMINANCE: {
		id: 1248,
		name: 'Giant Dominance',
		icon: iconUrl(213242),
		duration: 10000,
	},

	HOROSCOPE: {
		id: 1890,
		name: 'Horoscope',
		icon: iconUrl(213251),
		duration: 10000,
	},

	HOROSCOPE_HELIOS: {
		id: 1891,
		name: 'Horoscope Helios',
		icon: iconUrl(213252),
		duration: 30000,
	},

	NEUTRAL_SECT: {
		id: 1892,
		name: 'Neutral Sect (Healing Potency)',
		icon: iconUrl(213253),
		duration: 20000,
	},

	NEUTRAL_SECT_OTHERS: {
		id: 1921,
		name: 'Neutral Sect (Barrier)',
		icon: iconUrl(213255),
		duration: 30000,
	},

	INTERSECTION: {
		id: 1889,
		name: 'Intersection',
		icon: iconUrl(213250),
		duration: 30000,
	},

	OPPOSITION: {
		id: 1879,
		name: 'Opposition',
		icon: iconUrl(213246),
		duration: 15000,
	},

	DIVINATION: {
		id: 1878,
		name: 'Divination',
		icon: iconUrl(213245),
		duration: 20000,
	},

	EXALTATION: {
		id: 2717,
		name: 'Exaltation',
		icon: iconUrl(213262),
		duration: 8000,
	},

	MACROCOSMOS: {
		id: 2718,
		name: 'Macrocosmos',
		icon: iconUrl(213263),
		duration: 15000,
	},

	DIVINING: {
		id: 3893,
		name: 'Divining',
		icon: iconUrl(213264),
		duration: 30000,
	},

	HELIOS_CONJUNCTION: {
		id: 3894,
		name: 'Helios Conjunction',
		icon: iconUrl(213265),
		duration: 15000,
	},

	SUN_TOUCHED: {
		id: 3895,
		name: 'Suntouched',
		icon: iconUrl(213266),
		duration: 30000,
	},

	SUN_SIGN: {
		id: 3896,
		name: 'Sun Sign',
		icon: iconUrl(213267),
		duration: 15000,
	},

	// -----
	// Card buffs
	// -----

	THE_BALANCE: {
		id: 3887,
		name: 'The Balance',
		icon: iconUrl(213204),
		duration: 15000,
	},

	THE_BOLE: {
		id: 3890,
		name: 'The Bole',
		icon: iconUrl(213205),
		duration: 15000,
	},

	THE_ARROW: {
		id: 3888,
		name: 'The Arrow',
		icon: iconUrl(213206),
		duration: 15000,
	},

	THE_SPEAR: {
		id: 3889,
		name: 'The Spear',
		icon: iconUrl(213207),
		duration: 15000,
	},

	THE_EWER: {
		id: 3891,
		name: 'The Ewer',
		icon: iconUrl(213208),
		duration: 15000,
	},

	THE_SPIRE: {
		id: 3892,
		name: 'The Spire',
		icon: iconUrl(213209),
		duration: 15000,
	},

	// -----
	// Cards drawn
	// -----

	BALANCE_DRAWN: {
		id: 913,
		name: 'Balance Drawn',
		icon: iconUrl(213229),
	},

	BOLE_DRAWN: {
		id: 914,
		name: 'Bole Drawn',
		icon: iconUrl(213230),
	},

	ARROW_DRAWN: {
		id: 915,
		name: 'Arrow Drawn',
		icon: iconUrl(213231),
	},

	SPEAR_DRAWN: {
		id: 916,
		name: 'Spear Drawn',
		icon: iconUrl(213232),
	},

	EWER_DRAWN: {
		id: 917,
		name: 'Ewer Drawn',
		icon: iconUrl(213233),
	},

	SPIRE_DRAWN: {
		id: 918,
		name: 'Spire Drawn',
		icon: iconUrl(213234),
	},

	LORD_OF_CROWNS_DRAWN: {
		id: 2054,
		name: 'Lord of Crowns Drawn',
		icon: iconUrl(213256),
	},

	LADY_OF_CROWNS_DRAWN: {
		id: 2055,
		name: 'Lady of Crowns Drawn',
		icon: iconUrl(213257),
	},
})
